import { Heading, Paragraph, toast } from '@movingimage-evp/mi-ui-component-library';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { MediaContent } from './media-content';
import { Presentations } from './presentations';
import { EventStage } from '../../../../generated/graphql-manager';
import { useAbsoluteRoutes } from '../../../../routes';
import { SetupPageFooter } from '../../../components/setup-page-footer';

import managerStyles from '../../../manager.module.css';

export function MediaPage() {
  const { t } = useTranslation();
  const routes = useAbsoluteRoutes();
  const loadStartedRef = useRef(false);

  const handleLoadStart = () => {
    loadStartedRef.current = true;
  };

  const handleLoadEnd = () => {
    if (loadStartedRef.current) {
      toast(t('manager.webcastSetup.toast.saveSuccess'), 'positive');
      loadStartedRef.current = false;
    }
  };

  return (
    <main className={managerStyles.main} data-testid="media-page">
      <Heading className={managerStyles.grayText}>{t('manager.webcastSetup.media.title')}</Heading>
      <Paragraph>{t('manager.webcastSetup.media.heading')}</Paragraph>

      <MediaContent eventStage={EventStage.PRELIVE} onLoadStart={handleLoadStart} onLoadEnd={handleLoadEnd} />
      <MediaContent eventStage={EventStage.POSTLIVE} onLoadStart={handleLoadStart} onLoadEnd={handleLoadEnd} />
      <Presentations onLoadStart={handleLoadStart} onLoadEnd={handleLoadEnd} />

      <SetupPageFooter
        nextLabel={t('manager.webcastSetup.media.nextStep.label')}
        route={routes.webcastSetup_eventAccess}
      />
    </main>
  );
}
